// lib/i18n.ts
// Inicialización de i18next - importar al inicio de la app

import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { i18nextConfig } from "@/lib/locales";

// Inicializar i18next
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    ...i18nextConfig,

    // Debug solo en desarrollo
    debug: import.meta.env.DEV,

    // Opciones de detección de idioma
    detection: {
      // Orden de detección: localStorage > navigator > default
      order: ["localStorage", "navigator"],
      // Key en localStorage
      lookupLocalStorage: "i18nextLng",
      // Guardar en localStorage cuando cambie
      caches: ["localStorage"],
    },

    // Opciones de React
    react: {
      // Usar Suspense para loading (false = no mostrar fallback)
      useSuspense: false,
    },

    // Comportamiento de interpolación
    interpolation: {
      // React ya escapa valores, no duplicar
      escapeValue: false,
      // Formato de fechas por defecto
      format: (value: any, lng: string) => {
        if (value instanceof Date) {
          return new Intl.DateTimeFormat(lng).format(value);
        }
        return value;
      },
    },

    // Manejo de keys faltantes
    saveMissing: import.meta.env.DEV,
    missingKeyHandler: import.meta.env.DEV
      ? (lngs, ns, key) => {
          console.warn(
            `[i18n] Missing translation: ${ns}:${key} for ${lngs.join(", ")}`,
          );
        }
      : undefined,
  });

// Actualizar atributo lang del documento cuando cambie el idioma
i18n.on("languageChanged", (lng) => {
  document.documentElement.lang = lng;
  document.documentElement.dir = lng === "ar" || lng === "he" ? "rtl" : "ltr";
});

// Establecer idioma inicial en el documento
if (typeof document !== "undefined") {
  document.documentElement.lang = i18n.language;
}

export { i18n };
export default i18n;
